var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('state-badge',{staticClass:"entity-state",attrs:{"states":_vm.entityState.states,"data":_vm.entityState.data,"calculation":_vm.entityState.calculation,"busy":_vm.busy}})}
var staticRenderFns = []

export { render, staticRenderFns }